import React, { useState } from 'react';
import { Layers, Map as MapIcon, Globe, Image as ImageIcon } from 'lucide-react';

export type MapLayerType = 'osm' | 'geoportal' | 'satellite';

interface MapLayerControlProps {
    currentLayer: MapLayerType;
    onLayerChange: (layer: MapLayerType) => void;
    position?: 'bottom-right' | 'bottom-left';
}

const LAYERS: { id: MapLayerType; name: string; subtitle: string; icon: any; previewBg: string }[] = [
    {
        id: 'osm',
        name: 'Standardowa',
        subtitle: 'OpenStreetMap',
        icon: MapIcon,
        previewBg: 'linear-gradient(135deg, #a5b4fc 0%, #6ee7b7 100%)'
    },
    {
        id: 'geoportal',
        name: 'Ortomapa',
        subtitle: 'Geoportal (GUGiK)',
        icon: ImageIcon,
        previewBg: 'linear-gradient(135deg, #15803d 0%, #166534 50%, #854d0e 100%)'
    },
    {
        id: 'satellite',
        name: 'Satelita',
        subtitle: 'Esri Imagery',
        icon: Globe,
        previewBg: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 60%, #14532d 100%)'
    }
];

const MapLayerControl: React.FC<MapLayerControlProps> = ({ currentLayer, onLayerChange, position = 'bottom-right' }) => {
    const [isOpen, setIsOpen] = useState(false);

    const activeOption = LAYERS.find(l => l.id === currentLayer) || LAYERS[0];
    const ActiveIcon = activeOption.icon;

    const posStyle: React.CSSProperties = position === 'bottom-right'
        ? { position: 'absolute', bottom: '20px', right: '20px', zIndex: 1000 }
        : { position: 'absolute', bottom: '20px', left: '190px', zIndex: 1000 };

    return (
        <div style={posStyle} className="map-layer-control-wrapper">
            {isOpen && (
                <div className="map-layer-panel">
                    <div className="map-layer-panel-header">
                        <Layers size={15} />
                        <span>Wybierz podkład mapy</span>
                    </div>
                    <div className="map-layer-options">
                        {LAYERS.map(layer => {
                            const isSelected = currentLayer === layer.id;
                            const Icon = layer.icon;
                            return (
                                <button
                                    key={layer.id}
                                    type="button"
                                    className={`map-layer-card ${isSelected ? 'active' : ''}`}
                                    onClick={() => {
                                        onLayerChange(layer.id);
                                        setIsOpen(false);
                                    }}
                                >
                                    <div className="map-layer-thumb" style={{ background: layer.previewBg }}>
                                        <Icon size={20} color="white" strokeWidth={2.2} />
                                    </div>
                                    <div className="map-layer-meta">
                                        <span className="map-layer-name">{layer.name}</span>
                                        <span className="map-layer-sub">{layer.subtitle}</span>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* Główny kwadratowy przycisk przełącznika */}
            <button
                type="button"
                className={`map-layer-toggle-btn ${isOpen ? 'open' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                title="Zmień widok mapy (Standardowa / Ortomapa / Satelita)"
            >
                <div className="map-layer-toggle-preview" style={{ background: activeOption.previewBg }}>
                    <ActiveIcon size={20} color="white" strokeWidth={2.2} />
                </div>
                <div className="map-layer-toggle-label">
                    <span className="map-layer-toggle-title">{activeOption.name}</span>
                    <span className="map-layer-toggle-hint">Zmień</span>
                </div>
            </button>
        </div>
    );
};

export default MapLayerControl;
